export default {
  props: {
    navigation: {
      type: Array,
      required: true,
    },

    copyright: {
      type: String,
      required: true,
    },

    terms: {
      type: Object,
    },

    ethics: {
      type: Object,
    },

    corporate: {
      type: String,
    },

    propBus: {
      type: Object,
    },

    helpCenter: {
      type: Object,
    },
  },

  data() {
    return {
      year: null,
      availableLocales: ['pt-br', 'en', 'es'],
    }
  },

  mounted() {
    this.year = new Date().getFullYear()
  },

  computed: {
    hasCorporate() {
      return this.corporate ? true : false
    },

    hasHelpCenter() {
      return this.helpCenter ? true : false
    },
  },
}
